<template>
  <VisitView v-if="product.category_idx === 3"
             :loading="loading"
             :idx="idx" />
  <UnlimitedView v-else-if="product.category_idx === 5"
                 :loading="loading"
                 :idx="idx" />
  <VideoClassView v-else
                  :loading="loading"
                  :idx="idx" />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import VideoClassView from "@/components/ReadProduct/VideoClass";
  import VisitView from "@/components/ReadProduct/Visit";
  import UnlimitedView from "@/components/ReadProduct/Unlimited";

  export default {
    name: 'Product',
    props: [ 'idx' ],
    components: { VideoClassView, UnlimitedView, VisitView },
    data () {
      return {
        loading: true
      };
    },
    computed: {
      ...mapGetters('product', [ 'product' ]),
    },
		metaInfo () {
			return {
				title: this.product.title + ' - 유스',
				meta: [
					// SEO 설정
					{ name: 'description', content: this.product.contents },
					// SNS 설정
					{ property: 'og:title', content: this.product.title + ' - 유스' },
					{ property: 'og:description', content: this.product.contents },
					{ property: 'og:url', content: "https://www.youth.lol" + window.location.pathname },
					// 모바일 최적화
					{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
				]
			}
		},
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.selectProduct(vm.idx).then(() => {
          vm.loading = false;
          // vm.playerOptions.poster = vm.thumbnailSrc;
          // if (vm.product.preview) vm.playerOptions.sources = [{ src: `${vm.$storage}/video/preview/${vm.product.preview}`, type: 'video/mp4'}];
        });
      });
    },
    watch: {
      idx (val) {
        this.loading = true;
        this.selectProduct(val).then(() => {
          this.loading = false;
          // this.playerOptions.poster = this.thumbnailSrc;
          // if (this.preview) this.playerOptions.sources = [{ src: `${this.$storage}/video/preview/${this.preview}`, type: 'video/mp4'}];
        });
      }
    },
    methods: {
      ...mapActions('product', [ 'selectProduct' ]),
    }
  };
</script>

<style lang="scss" scoped>
  .channel-small-icon {
    flex-shrink: 0;

    width: 33px;
    /*height: 19px;*/
    line-height: 19px;
    border-radius: 8px;
    background-color: map_get($colors, charcoal);

    color: white;
    font-size: 10px;
  }

  .custom-chip {
    padding: 0 6px;
    line-height: 22px;
    background-color: map_get($colors, charcoal);
    border-radius: 5px;

    color: white;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: -0.2px;
  }

  .summary-text {
    padding-right: 20px;
    padding-left: 20px;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: map_get($colors, charcoal);
  }

  /deep/.extension-padding .v-toolbar__extension {
    padding: 0;
  }

  .top-button {
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
    &.v-btn--depressed {
      border-color: #cdcdcd !important;
    }
  }

  .top-right-radius {
    width: auto;
    border-top-right-radius: 40px;
    box-shadow: 0 -8px 10px 0 rgba(black, 0.06);
  }

  .summary-more-gradient {
    position: absolute;
    top: 16px;
    left: 0;
    width: 100%;
    height: 120px;
    background-image: linear-gradient(to bottom, rgba(#f8f8f8, 0) 50%, rgba(#f8f8f8, 1) 100%);
  }

  .installment-tooltip {
    margin-left: 8px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    font-weight: 700;
    color: white;
    border-radius: 50%;
    background-image: linear-gradient(to bottom, #818181, #4a4a4a);
  }

  .package {
    &-text {
      font-size: 14px;
      letter-spacing: -0.2px;
      color: map_get($colors, charcoal);
      line-height: 24px;
    }
    &-text-big {
      font-weight: 300;
      font-size: 24px;
      letter-spacing: -0.3px;
      color: map_get($colors, charcoal);
      line-height: 30px;
    }
  }

  .purchase-button {
    border-radius: 24px;
    background-color: white;
    margin-left: 16px;
    margin-right: 16px;

    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.3px;
  }

  /deep/ .v-tabs__container {
    align-items: center;
    justify-content: space-between;
    height: 40px;
  }

  /deep/.tab {
    & > a {
      padding-left: 0;
      padding-right: 0;
      color: map_get($colors, brown-crey);
      font-size: 16px;
      letter-spacing: -0.3px;
      &.v-tabs__item--active {
        color: map_get($colors, charcoal);
      }
    }
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map_get($colors, background-shadow);
  }

  .footer-style {
    color: white;
  }

  .display-4 {
    word-break: keep-all;
    word-wrap: break-word;
  }

  /deep/.expansion-panel-style {
    box-shadow: none;
    .v-expansion-panel__header {
      /*height: 100%;*/
      justify-content: center;
      background-image: linear-gradient(to bottom, white, #f8f8f8);
    }
    .v-expansion-panel__container--active {
      .v-expansion-panel__header {
        background-image: none;
      }
    }
    .v-expansion-panel__header__icon {
      width: 16px;
      height: 16px;
      i {
        vertical-align: baseline;
      }
      i:before {
        font-size: 16px;
      }
    }
  }

  .chapter-text {
    font-size: 16px;
    font-weight: 700;
    color: map_get($colors, primary) !important;
    letter-spacing: -0.3px;
    padding-bottom: 8px;

    word-break: keep-all;
    white-space: pre-wrap;
  }

  /deep/.list-padding .v-list__tile {
    padding-right: 6px;
    height: auto;
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

  /deep/ .package-more-holder {
     text-align: left;
     width: 100%;
     max-width: 360px;
     margin: auto;
     align-items: center;
     & > .text-wrapper {
       min-width: 280px;
     }
  }

  .lecture-title {
    white-space: pre-wrap;
    padding-left: 20px;
    &:before {
      content: '\2022';
      position: absolute;
      left: 20px;
    }
  }

  .more-button-style {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.2px;
    color: #4a4a4a !important;
    text-transform: unset;
    height: 38px;
    border: 1px solid #cdcdcd !important;
    border-radius: 19px;
    background-color: #f8f8f8 !important;
  }

  ::v-deep.v-tooltip__content {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
</style>
